module.exports = __webpack_public_path__ + "img/4.2.ad129723.svg";